function prevSlide() {
	slideIndex -= 3;
	slideDots -= 1;
	if (slideIndex < 0 || slideDots < 0) {
		slideIndex = 6;
		slideDots = 2;
	}
	showSlides(slideIndex, slideDots);
}